import { HTTP } from "@/core/http";
import type {
  ChatMessage,
  ChatHistoryResponse,
  SendChatMessageRequest,
  SendChatMessageParams,
} from "../types";

export class ChatService {
  constructor(private readonly httpClient: HTTP) {}

  /**
   * Get chat history for a conversation
   */
  async getChatHistory(conversationUuid: string): Promise<ChatMessage[]> {
    const response = await this.httpClient.get<
      ChatHistoryResponse | ChatMessage[]
    >(`/projects/chat/${conversationUuid}/history`);

    // Handle both array and object with messages property
    if (Array.isArray(response)) {
      return response;
    }

    if (response && typeof response === "object" && "messages" in response) {
      return (response as ChatHistoryResponse).messages || [];
    }

    return [];
  }

  /**
   * Send a chat message and get streaming response
   * @returns Raw Response object for streaming
   */
  async sendChatMessage(params: SendChatMessageParams): Promise<Response> {
    const requestBody: SendChatMessageRequest[] = [
      {
        conversation_uuid: params.conversationUuid,
        message_uuid: params.messageUuid,
        parent_uuid: params.parentUuid,
        role: "user",
        message: {
          content: [
            {
              type: "text",
              data: params.content,
              language: "",
              url: "",
              name: "",
            },
          ],
        },
      },
    ];

    return this.httpClient.post<Response, SendChatMessageRequest[]>(
      "/chat/stream",
      {
        body: requestBody,
        returnRawResponse: true,
      }
    );
  }
}
